<template>
  <div>
    <div class="select">
      <el-cascader class="input"
                   placeholder="请选择部门及岗位"
                   v-model="station_id"
                   :options="optionsList"
                   clearable>
      </el-cascader>
      <el-input
        v-model="id_number"
        placeholder="身份证号"
        class="input"
        clearable></el-input>
      <el-input
        v-model="name"
        placeholder="姓名"
        class="input"
        clearable></el-input>
      <el-cascader
        style="width: 155px"
        @change="descExcu"
        placeholder="请选择排序"
        v-model="desc"
        :options="descArr">
      </el-cascader>
      <el-button type="primary" @click="queryData">查 询</el-button>
      <el-button style="float:right;margin-right:3rem" type="primary" @click="exam">批改试卷</el-button>
      <el-button style="float:right;margin-right:3rem" type="primary" @click="openShow(null,2)">待审核人员</el-button>
    </div>
    <el-card>
      <div class="select">
        <el-table
          height="440"
          :data="userData"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
            <template slot-scope="scope">
              <span>{{ (page - 1) * size + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="age"
            label="年龄">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="电话">
          </el-table-column>
          <el-table-column
            prop="id_number"
            label="身份证">
          </el-table-column>
          <el-table-column
            label="岗位">
            <template slot-scope="scope">
              <div>
                {{ scope.row.branch }} / {{ scope.row.station }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="学习时间">
            <template slot-scope="scope">
              <div>
                {{ getNowTimes(scope.row.final_time) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="考试时间">
            <template slot-scope="scope">
              {{ timeFomat(scope.row.exam_time) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="openShow(scope.row, 1)">编辑</el-button>
              <el-button size="small" type="primary" @click="datalist(scope.row)">查看</el-button>
              <el-button size="small" type="danger" @click="delUser(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="center select">
        <el-pagination
          background
          layout="prev, pager, next, total, jumper"
          :total="total"
          :current-page="page"
          :page-size="size"
          @current-change="pagechange">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="updateDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="0"
      center>
      <div slot="footer" class="dialog-footer" style="display: block">
        <update ref="updateV" v-if="model == 1" :data_json="updateData"></update>
        <regPesonlist v-else-if="model == 2"></regPesonlist>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as req from '@/utils/request'

import {formatDate} from '../utils/timeUtils'
import update from '../components/update_dialog'
import regPesonlist from '../components/regPesonlist'

export default {
  components: {
    update,
    regPesonlist
  },
  data () {
    return {
      total: 0,
      updateDialog: false,
      page: 1,
      size: 12,
      Time: [],
      // 默认是按照学习时长排序
      desc: 'final_time',
      station_id: null,
      branch_id: 0,
      // 所有部门
      branchList: [],
      // 岗位列表
      stationList: [],
      // 选项数组
      optionsList: [],
      // 身份证
      id_number: '',
      // 姓名
      name: '',
      updateData: {},
      // 数据
      userData: [],
      model: 0,
      // dataList: [],
      descArr: [
        {
          label: '按学习时间排序',
          value: 'final_time'
        },
        {
          label: '按考试时间排序',
          value: 'exam_time'
        }
      ]
    }
  },
  filters: {
    formatDate (time) {
      time = time * 1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getBranchList()
      this.getStationList()
      this.getData()
    })
  },
  created () {
    this.getBranchList()
    this.getStationList()
    // this.getData()
  },
  beforeMount () {
    console.log('进入页面')
    this.getData()
  },
  methods: {
    descExcu (data) {
      this.desc = data['0']
      this.getData()
    },
    delUser (id) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let msg = {}
        msg.id = id
        let sendData = {}
        sendData.data = msg
        sendData.fn = this.delUserFn
        sendData.vm = this
        req.Delete('user/del_User', sendData)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delUserFn (data) {
      if (data.err_code !== 0) {
        this.$message.error('删除失败')
        return
      }
      this.getData()
      this.$message.success('删除成功')
    },
    timeFomat (time) {
      if (time === '1970-01-01') {
        return 'N/A'
      }
      return time
    },
    openShow (data, index) {
      this.model = index
      this.updateData = data
      // 如果data == null则进入审核人员弹窗
      // if (data == null){
      // }

      this.updateDialog = true
      // this.$refs.updateV.selec[0] = data.branch_id
      // this.$refs.updateV.selec[1] = data.station_id
    },
    sortByDate (obj1, obj2) {
      let val1 = obj1.exam_time
      let val2 = obj2.exam_time
      return val1 - val2
    },
    queryData () {
      this.page = 1
      this.getData()
    },
    // 将秒转化为时分
    getTime (endTime) {
      if (endTime === null) {
        return '0 分'
      }
      let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
      let min = 0 // 初始化分
      let h = 0 // 初始化小时
      let result = ''
      if (secondTime > 59) { // 如果秒数大于59，将秒数转换成整数
        min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
        if (min > 60) { // 如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, '0')} 小时 ${min.toString().padStart(2, '0')}分`
      return result
    },
    // 获取部门列表
    getBranchList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getBranchListFn
      sendData.vm = this
      req.Post('branch/get_branch', sendData)
    },
    getBranchListFn (data) {
      this.branchList = []
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      for (let i in data.list) {
        // if (data.list[i].branch !== '岸基部') {
        this.branchList.push(data.list[i])
        // }
      }
    },
    // 精确到秒
    getNowTimes (shijian) {
      if (shijian === null) {
        return 'N/A'
      }
      return new Date(parseInt(shijian) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
      // var date = new Date(shijian)
      // var Y = date.getFullYear() + '-'
      // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      // var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      // var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      // var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      // var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      // return Y + M + D + h + m + s
    },
    // 获取岗位列表
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.stationList = data.list
      let array = this.getOptions()
      this.global.optionsList = array

      let f = JSON.parse(JSON.stringify(array))
      for (let i in f) {
        if (f[i].label === '岸基部') {
          delete f[i]
        }
      }
      this.optionsList = f
    },
    // 生成部门和岗位选项
    getOptions () {
      let branchList = this.branchList
      let stationList = this.stationList
      console.log(branchList, stationList)
      let ary = []
      for (let i in branchList) {
        let obj = {}
        obj.value = branchList[i].id
        obj.label = branchList[i].branch
        let children = this.getChildren(branchList[i].id, stationList)
        if (children.length > 0) {
          obj.children = children
        }
        ary.push(obj)
      }

      return ary
    },
    // 根据部门id获取所属岗位
    getChildren (branchId, stationList) {
      let ary = []
      for (let i in stationList) {
        if (stationList[i].branch_id === branchId) {
          let obj = {}
          obj.value = stationList[i].id
          obj.label = stationList[i].station
          ary.push(obj)
        }
      }
      return ary
    },
    // 查询
    getData () {
      // this.page = 1
      let obj = {}
      let data = {}
      if (this.station_id) {
        let val = this.station_id
        data.station_id = val[1]
        data.branch_id = val[0]
      }
      if (this.id_number) {
        data.id_number = this.id_number
      }
      if (this.name) {
        data.name = this.name
      }
      data.page = this.page - 1
      data.size = this.size
      obj.data = data
      obj.desc = this.desc
      let sendData = {}
      sendData.data = obj
      sendData.vm = this
      sendData.fn = this.resData
      req.Post('user/get_UserData', sendData)
    },
    // 查询回调
    resData (data) {
      this.userData = data.userData
      this.total = data.count
    },
    // 分页监听
    pagechange (data) {
      this.page = data
      this.getData()
    },
    // 处理错误数据
    errToValue (data) {
      let vas = data.study_record
      if (!vas || ['', '{}'].includes(vas)) {
        data.study_record = {}
      } else if (data.study_record !== {}) {
        // 用户已有学习记录数据
        data.study_record = JSON.parse(data.study_record)
      }
      let list = []
      if (['null', '', '[]', null].includes(data.played)) {
        data.played = []
      } else {
        let obj = JSON.parse(data.played)
        obj.map((value) => {
          if (value) {
            list.push(value)
          }
        })
      }
      data.played = list
      return data
    },
    // 查看
    datalist (data) {
      window.$global.dataList = this.errToValue(data)
      this.$router.push({path: '/dataList'})
    },
    // 去考试页
    exam () {
      this.$router.push({path: '/correct'})
    }
  }
}
</script>

<style scoped>
.select {
  padding: 10px;
  flex-direction: row;
  flex-wrap: nowrap;
}

.input {
  width: 15rem;
}

.center {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/page/selectTable.vue